import { render, staticRenderFns } from "./ListWrapper.vue?vue&type=template&id=4aacc823"
import script from "./ListWrapper.vue?vue&type=script&lang=js"
export * from "./ListWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports